import Component from '@component';

class OnLoaded extends Component {
	onInit() {
		this.elJsons = document.querySelectorAll('.js-gtm-loaded-json');
		this.jsons = [];
		this.parseUrl();
	}

	parseUrl() {
		this.parseScript();
	}

	parseScript() {
		if (!this.elJsons.length) return false;
		this.elJsons.forEach((elJson) => {
			this.jsons.push(JSON.parse(elJson.textContent));
		});
	}

	onLoad() {
		if (window.dataLayer != void 0) {
			this.jsons.forEach((json) => {
				window.dataLayer.push(json);
			});
		}
	}
}

export default new OnLoaded();
